// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveySessionValuePostRequest {
    static getAttributeTypeMap() {
        return SurveySessionValuePostRequest.attributeTypeMap;
    }
}
SurveySessionValuePostRequest.discriminator = undefined;
SurveySessionValuePostRequest.attributeTypeMap = [
    {
        "name": "surveySessionId",
        "baseName": "surveySessionId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerId",
        "baseName": "answerId",
        "type": "number"
    },
    {
        "name": "answerValue",
        "baseName": "answerValue",
        "type": "string"
    }
];
//# sourceMappingURL=surveySessionValuePostRequest.js.map